import React from 'react';
import Layout from '../../../components/Layout';
import NotFound from '../../notFound/NotFound';
import Page from '../../../components/Page';
import fetch from '../../../core/fetch';

const query = `query getEditStaticPage ($id: Int!) {
  getEditStaticPage (id: $id) {
      id
      pageName
      content
      metaTitle
      metaDescription
      createdAt
      isEnable
  }
}`;

export default async function action({ locale }) {

    const resp = await fetch('/graphql', {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: query,
            variables: { id: 7 },
        }),
        credentials: 'include',
    });

    const { data } = await resp.json();
    let isEnable = data?.getEditStaticPage?.isEnable;
    if (isEnable !== undefined && isEnable == false) {
        return {
            title: data?.getEditStaticPage?.metaTitle,
            description: data?.getEditStaticPage?.metaDescription,
            component: <Layout><NotFound /> </Layout>,
        };
    }

    return {
        title: data?.getEditStaticPage?.metaTitle,
        description: data?.getEditStaticPage?.metaDescription,
        component: <Layout><Page html={data?.getEditStaticPage?.content} title={data?.getEditStaticPage?.metaTitle} /></Layout>,
    };

}
